(() => {
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {cache:'no-store'})
    .then(response => response.ok ? response.json() : null)
    .then(data => { const country=data?.detected_values?.country?.handle; if(country)document.documentElement.dataset.fluffeVisitorCountry=country; })
    .catch(() => {});
  const noteVariants = {'Blank note card':67784559034690,'Handwritten message':67784559067458};
  const isNoteCard = item => Object.values(noteVariants).includes(Number(item.variant_id));
  const cartEvents = import('@shopify/events');
  async function giftCartRequest(path, body) {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
    if (!response.ok) throw new Error('Could not update note card');
    return response.json();
  }
  class GiftNote extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.ready = true;
        this.card = this.querySelector('[data-gift-card]');
        this.message = this.querySelector('[data-gift-message]');
        this.status = this.querySelector('[data-gift-status]');
        this.saved = this.value();
        this.refresh();
        this.addEventListener('change', () => { this.refresh(); this.save(); });
        this.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.save(), 600); });
        this.querySelector('[data-save-gift]').addEventListener('click', () => this.save());
      }
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      cartEvents.then(({StandardEvents}) => {
        if (signal.aborted) return;
        document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
          try {
            const result = await event.promise;
            if (this.pending || this.value() !== this.saved || result?.detail?.source === 'fluffe-gift-note') return;
            const cart = await giftCartRequest('cart.js');
            if (this.pending || this.value() !== this.saved || !this.isConnected) return;
            const line = cart.items.find(isNoteCard);
            this.card.value = line ? Object.keys(noteVariants).find(style => noteVariants[style] === Number(line.variant_id)) : '';
            this.message.value = line?.properties?.Message || '';
            this.saved = this.value(); this.refresh(); this.status.textContent = '';
          } catch {}
        }, {signal});
      }).catch(() => {});
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
    value() { return JSON.stringify({'Gift card':this.card.value,'Gift message':this.card.value === 'Handwritten message' ? this.message.value.trim() : ''}); }
    refresh() { this.querySelector('[data-message-label]').hidden = this.card.value !== 'Handwritten message'; }
    async save() {
      clearTimeout(this.timer);
      if (this.pending) { await this.pending; if (this.saved !== this.value()) return this.save(); return true; }
      const value = this.value();
      if (value === this.saved) return true;
      const attributes = JSON.parse(value), style = attributes['Gift card'], message = attributes['Gift message'];
      if (style === 'Handwritten message' && !message) { this.status.textContent = 'Write your message, or choose a blank note card.'; return false; }
      this.status.classList.remove('fluffe-shopping-error');
      this.status.textContent = 'Saving note card…';
      this.pending = (async () => {
        try {
          const {CartLinesUpdateEvent} = await cartEvents;
          await Promise.all(customElements.get('cart-items-component')?.pendingQuantityUpdates || []);
          let cart = await giftCartRequest('cart.js');
          const cards = cart.items.filter(isNoteCard);
          const variant = noteVariants[style];
          const matching = cards.find(item => Number(item.variant_id) === variant);
          const properties = message ? {Message:message} : {};
          if (variant) {
            if (matching) await giftCartRequest('cart/change.js', {id:matching.key,quantity:1,properties});
            else await giftCartRequest('cart/add.js', {items:[{id:variant,quantity:1,properties}]});
          }
          const updates = {};
          cards.filter(item => !variant || item.key !== matching?.key).forEach(item => { updates[item.key] = 0; });
          const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
          cart = await giftCartRequest('cart/update.js', {updates,attributes,sections:sections.join(','),sections_url:location.pathname});
          this.saved = value;
          this.status.textContent = style ? 'Note card added to your order.' : 'Note card removed.';
          document.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:cart.sections,items:cart.items,itemCount:cart.item_count,source:'fluffe-gift-note',didError:false}})}));
          return true;
        } catch { this.status.textContent = 'Could not save. Please try Save gift options again before checkout.'; this.status.classList.add('fluffe-shopping-error'); return false; }
      })();
      const ok = await this.pending; this.pending = null; return ok;
    }
  }
  if (!customElements.get('fluffe-gift-note')) customElements.define('fluffe-gift-note',GiftNote);
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('button[name="checkout"],a[href$="/checkout"]');
    if (!checkout || checkout.dataset.fluffeReady === 'true') return;
    const notes = [...document.querySelectorAll('fluffe-gift-note')].filter(el => el.ready && (el.pending || el.value() !== el.saved));
    if (!notes.length) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const saved = await Promise.all(notes.map(el => el.save()));
    if (saved.every(Boolean)) { checkout.dataset.fluffeReady = 'true'; checkout.click(); delete checkout.dataset.fluffeReady; }
    else { const note = notes.find(el=>el.value()!==el.saved); if(note){note.querySelector('details').open=true;note.scrollIntoView({block:'center'});} }
  }, true);
  const categoryNames = {'all':'All','fluffe':'Fluffe','potion-floss':'Potion Floss','gift-wrap':'Gift Wrap','merch':'Merch'};
  const productCategory = type => type.includes('potion') ? 'potion-floss' : /gift-wrap|keepsake|packaging/.test(type) ? 'gift-wrap' : /merch|apparel|accessories/.test(type) ? 'merch' : /fluffe|fairy-floss|cotton-candy/.test(type) ? 'fluffe' : '';
  const applyCategory = () => {
    const value = new URL(location.href).searchParams.get('fluffe_category') || 'all';
    const selected = categoryNames[value] ? value : 'all';
    document.querySelectorAll('fluffe-category-filter').forEach(control => {
      control.querySelectorAll('[data-product-category]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.productCategory === selected)));
      const label=control.querySelector('[data-category-label]');
      const text=selected==='all' ? 'Category' : categoryNames[selected];
      if(label.textContent!==text)label.textContent=text;
    });
    document.querySelectorAll('results-list').forEach(results => {
      const cards=[...results.querySelectorAll('.product-grid__item[data-product-type]')];
      if(!cards.length)return;
      let count=0;
      cards.forEach(card=>{const show=selected==='all'||productCategory(card.dataset.productType)===selected;card.classList.toggle('fluffe-filter-hidden',!show);if(show)count++;});
      results.querySelectorAll('[data-testid="products-count"] [role="status"]').forEach(label=>{const text=count+(count===1?' item':' items');if(label.textContent!==text)label.textContent=text;});
      const grid=results.querySelector('.product-grid');
      if(grid){
        const columns=getComputedStyle(grid).gridTemplateColumns.split(' ').length;
        grid.classList.toggle('fluffe-featured-center',columns>=5);
        let empty=results.querySelector('[data-category-empty]');
        if(!empty){empty=document.createElement('p');empty.dataset.categoryEmpty='';empty.setAttribute('role','status');empty.textContent='No products in this category match your current filters.';grid.after(empty);}
        empty.hidden=count>0;
      }
    });
    document.querySelectorAll('facets-form-component form').forEach(form=>{
      let input=form.querySelector('input[name="fluffe_category"]');
      if(selected==='all'){input?.remove();return;}
      if(!input){input=document.createElement('input');input.type='hidden';input.name='fluffe_category';form.append(input);}
      input.value=selected;
    });
    document.querySelectorAll('.facets__see-results').forEach(button=>{
      const count=document.querySelectorAll('results-list .product-grid__item[data-product-type]:not(.fluffe-filter-hidden)').length;
      const text='Show '+count+(count===1?' item':' items');if(button.textContent!==text)button.textContent=text;
    });
  };
  class CategoryFilter extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-product-category]');if(!button)return;
        event.preventDefault();event.stopPropagation();
        const url=new URL(location.href), category=button.dataset.productCategory;
        if(category==='all')url.searchParams.delete('fluffe_category');else url.searchParams.set('fluffe_category',category);
        history.pushState({},'',url);
        document.querySelectorAll('.fluffe-category-panel').forEach(panel=>panel.open=false);
        applyCategory();
      });
      queueMicrotask(applyCategory);
    }
  }
  if(!customElements.get('fluffe-category-filter'))customElements.define('fluffe-category-filter',CategoryFilter);
  let categoryFrame;
  const scheduleCategory=()=>{cancelAnimationFrame(categoryFrame);categoryFrame=requestAnimationFrame(applyCategory);};
  const categoryRoot=document.getElementById('MainContent');
  if(categoryRoot){new MutationObserver(scheduleCategory).observe(categoryRoot,{childList:true,subtree:true});scheduleCategory();}
  window.addEventListener('popstate',scheduleCategory);
  window.addEventListener('resize',scheduleCategory);
  const help = document.getElementById('fluffe-builder-help');
  if (!help) return;
  const install = () => {
    const builder = document.getElementById('bundlesuiteContainer');
    const header = builder?.querySelector('.template-top-data');
    if (!header || builder.querySelector('.fluffe-builder-help')) return;
    header.after(help.content.cloneNode(true));
    const panel = builder.querySelector('.fluffe-builder-help');
    const progress = panel.querySelector('[data-builder-progress]');
    const pickMix = panel.dataset.builderKind === 'pick-mix';
    let targetCount = 0;
    if (pickMix) {
      const holder = panel.querySelector('[data-surprise-tiers]');
      const tiers = window.BYOBConfig?.discount?.tiers || [];
      [...new Set(tiers.map(tier => Number(tier.requirement)))].filter(count => Number.isInteger(count) && count > 0 && count <= 100).sort((a,b)=>a-b).forEach(count => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'fluffe-button';
        button.dataset.discoveryFill = String(count);
        button.textContent = 'Surprise ' + count;
        holder.append(button);
      });
    }
    const countSelections = () => {
      let boxes=0,flavours=0;
      builder.querySelectorAll('.main-wrapper .product-card[data-product-handle]').forEach(card=>{
        const controls=card.querySelector('.quantity-controls');
        if (!controls || controls.style.display==='none' || !controls.querySelector('.quantity-input')) return;
        const count=Number(controls.querySelector('.quantity-input').value)||0;
        if(card.dataset.productHandle.includes('keepsake-box')) boxes+=count; else flavours+=count;
      });
      const message='';
      if(progress.textContent!==message) progress.textContent=message;
      return {boxes,flavours};
    };
    const surpriseButtons=[...panel.querySelectorAll('[data-discovery-fill]')];
    let choosing=false;
    const selectedCount=card=>{
      const controls=card.querySelector('.quantity-controls');
      return controls && controls.style.display!=='none' ? Number(controls.querySelector('.quantity-input')?.value)||0 : 0;
    };
    const shuffle=items=>{
      const result=[...items];
      for(let i=result.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[result[i],result[j]]=[result[j],result[i]];}
      return result;
    };
    const chooseAvailable=async(cards,count)=>{
      const chosen=[];
      for(const card of shuffle(cards)){
        const button=card.querySelector('.add-button');
        if(!button || button.dataset.stockStatus!=='in-stock' || button.dataset.preOrder==='true')continue;
        const response=await fetch(root+'products/'+encodeURIComponent(card.dataset.productHandle)+'.js',{cache:'no-store'});
        if(!response.ok)throw new Error('availability');
        const product=await response.json();
        if(product.available && product.variants.some(variant=>variant.available))chosen.push(card);
        if(chosen.length===count)return chosen;
      }
      return chosen;
    };
    const waitFor=async(test)=>{
      for(let attempt=0;attempt<30;attempt++){if(test())return;await new Promise(resolve=>setTimeout(resolve,100));}
      throw new Error('selection');
    };
    surpriseButtons.forEach(surpriseButton => surpriseButton.addEventListener('click',async()=>{
      if(choosing)return;
      choosing=true;
      const label=surpriseButton.textContent;
      const requested=pickMix ? Number(surpriseButton.dataset.discoveryFill) : 6;
      surpriseButtons.forEach(button=>button.disabled=true);
      surpriseButton.textContent='Choosing…';
      progress.textContent=pickMix ? 'Checking available flavours…' : 'Checking available flavours and boxes…';
      try{
        const cards=[...new Map([...builder.querySelectorAll('.main-wrapper .product-card[data-product-handle]')].map(card=>[card.dataset.productHandle,card])).values()];
        const isBox=card=>card.dataset.productHandle.includes('keepsake-box');
        const [boxes,flavours]=await Promise.all([pickMix ? Promise.resolve([]) : chooseAvailable(cards.filter(isBox),1),chooseAvailable(cards.filter(card=>!isBox(card)),requested)]);
        if(pickMix ? !flavours.length : boxes.length!==1 || flavours.length!==6){progress.textContent=pickMix ? 'No available flavours could be found. Please check the options below.' : 'Surprise me needs one available box and six different available flavours. Please choose from the available options below.';return;}
        targetCount=requested;
        for(const card of cards){
          let count=selectedCount(card);
          while(count>0){card.querySelector('.quantity-controls .minus').click();await waitFor(()=>selectedCount(card)<count);count=selectedCount(card);}
        }
        for(const card of [...boxes,...flavours]){
          const button=card.querySelector('.add-button');
          if(!button || button.disabled || button.dataset.stockStatus!=='in-stock')throw new Error('selection');
          button.click();await waitFor(()=>selectedCount(card)===1);
        }
        if(pickMix){
          const blocked=new Set();
          let total=countSelections().flavours;
          while(total<requested){
            const candidates=shuffle(flavours).filter(card=>!blocked.has(card)).sort((a,b)=>selectedCount(a)-selectedCount(b));
            if(!candidates.length)throw new Error('insufficient stock');
            const card=candidates[0], before=selectedCount(card);
            const plus=card.querySelector('.quantity-controls .plus');
            if(!plus || plus.disabled){blocked.add(card);continue;}
            plus.click();
            try{await waitFor(()=>selectedCount(card)>before);}catch{blocked.add(card);continue;}
            total=countSelections().flavours;
          }
        }
        countSelections();
      }catch{progress.textContent='We couldn’t finish the surprise selection. Please check your choices below and try again.';}
      finally{choosing=false;surpriseButtons.forEach(button=>button.disabled=false);surpriseButton.textContent=label;}
    }));
    const watch = new MutationObserver(()=>{if(!choosing)countSelections();});
    const cart=builder.querySelector('.side-cart-products');
    if(cart)watch.observe(cart,{childList:true,subtree:true,characterData:true});
    builder.addEventListener('click',event=>{if(!event.target.closest('.fluffe-builder-help'))setTimeout(()=>{if(!choosing)countSelections();},200);});
    countSelections();
  };
  install();
  const observer=new MutationObserver(()=>{install();if(document.querySelector('#bundlesuiteContainer .fluffe-builder-help'))observer.disconnect();});
  observer.observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
})();

(() => {
  if (!document.querySelector('#fluffe-builder-help')?.content.querySelector('[data-builder-kind="gift-set"]')) return;
  const price = document.querySelector('#fluffe-builder-help').content.querySelector('[data-gift-set-price]')?.textContent;
  if (!price) return;
  const update = () => {
    const cart = document.querySelector('#bundlesuiteContainer .side-cart-container');
    if (!cart) return;
    cart.querySelectorAll('.remove-item-btn').forEach(button => {
      if (button.textContent !== 'remove') button.textContent = 'remove';
      const title = button.closest('.sc-product-item')?.querySelector('.scpt-title')?.textContent.trim();
      const label = 'Remove ' + (title || 'item');
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    const total = cart.querySelector('.total-value');
    if (total && total.textContent !== price) total.textContent = price;
  };
  const builder = document.body;
  if (builder) {
    new MutationObserver(update).observe(builder, {childList:true,subtree:true,characterData:true});
    update();
  }
})();

